import { DhlModal } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledDhlModal = styled(DhlModal)`
  & .dialog-container {
    z-index: 100;
  }
  & .card-container {
    width: fit-content;
    padding: 2rem;
  }
`;

const ModalContent = styled.div`
  width: fit-content;
  min-width: 400px;
`;

export const Modal = (props) => {
  const { isOpen, onClose, children } = props;

  return (
    <StyledDhlModal isOpen={isOpen} handleOnClose={onClose} trapFocus={false}>
      <ModalContent>{children}</ModalContent>
    </StyledDhlModal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default Modal;
